import axios from 'axios'
import store from '@/store'

const dashboardClient = axios.create({})

// El dashboard dispara ~10 requests en paralelo al montar (useDashboard.js ->
// loadData()) contra el mismo host de tenant que el resto de microservicios
// (mismo origen para el navegador). Si el usuario navega a otra pantalla
// mientras esos requests siguen en vuelo, no se cancelan solos: siguen
// compitiendo por el límite de conexiones concurrentes del navegador contra
// los requests de la pantalla nueva, haciéndola sentir lenta.
//
// OJO: este mismo cliente lo usan también patients, covid, vaccinations,
// special-labels, cie-diagnostics, affected-systems, assignments-concentrated
// y el chip de usuarios activos del header (visible en TODA la app) — pantallas
// que NO son el dashboard. Por eso el registro es opt-in por request
// (`config.cancelOnDashboardUnmount`), no "cancela todo lo que use este
// cliente": un cancelPendingDashboardRequests() ciego abortaría requests
// legítimos de la pantalla a la que se está navegando.
const pendingControllers = new Set()

export function attachCancellation(config) {
    const controller = new AbortController()
    config.signal = controller.signal
    config.__abortController = controller

    if (config.cancelOnDashboardUnmount) {
        pendingControllers.add(controller)
    }

    return config
}

export function releaseCancellation(responseOrError) {
    const controller = responseOrError?.config?.__abortController
    if (controller) pendingControllers.delete(controller)
}

/** Cancela todo lo que siga en vuelo (llamar al desmontar Dashboard.vue). */
export function cancelPendingDashboardRequests() {
    pendingControllers.forEach((controller) => controller.abort())
    pendingControllers.clear()
}

dashboardClient.interceptors.request.use(config => {
    config.headers.Authorization = `Bearer ${store.getters['auth/getToken']}`
    config.headers.lang = store.getters['getLang']
    config.url = `${process.env.VUE_APP_PROTOCOL}://${store.getters['auth/getTenantHost']}/dashboard/api/v1${config.url}`
    return attachCancellation(config);
})

dashboardClient.interceptors.response.use(
    (response) => {
        releaseCancellation(response)
        return response
    },
    (error) => {
        releaseCancellation(error)
        return Promise.reject(error)
    }
)

export default dashboardClient
